















import Vue from 'vue'
import { mapActions, mapMutations } from 'vuex'
import { getCookie } from '@/utils'
import { setToken } from '@/utils/auth'
import { resetRouter } from '@/router'

export default Vue.extend({
  name: 'index',
  data() {
    return {}
  },
  created() {
    this.fastLogin()
  },
  methods: {
    ...mapActions({
      generateRoutes: 'permission/generateRoutes',
      setAppName: 'app/setAppName',
      initializeLang: 'i18n/initializeLang',
      setButtons: 'permission/setButtons'

    }),
    ...mapMutations({
      SET_ROUTES: 'permission/SET_ROUTES',
      SET_TOKEN: 'user/SET_TOKEN',
      SET_USER: 'user/SET_USER',
      SET_ISHOST: 'user/SET_ISHOST'
    }),
    async fastLogin() {
      const infos = [
        'access_token',
        'account',
        'avatar',
        'client_id',
        'dept_id',
        'expires_in',
        'jti',
        'license',
        'nick_name',
        'oauth_id',
        'post_id',
        'real_name',
        'refresh_token',
        'role_id',
        'role_name',
        'scope',
        'tenant_id',
        'token_type',
        'user_id',
        'user_name']
      let userInfo: any = {}
      infos.map(item => {
        userInfo[item] = getCookie(item)
      })
      if (userInfo.avatar) {
        userInfo.avatar = userInfo.avatar.replace(/"/g, "")
      }
      console.log('info form cookie:', userInfo)
      setToken(userInfo.access_token)
      this.SET_TOKEN(userInfo.access_token)
      this.SET_USER(userInfo)
      this.SET_ISHOST(userInfo.tenant_id)

      let appCode = 'console'
      await this.setAppName('控制台')
      resetRouter()
      const accessRoutes = await this.generateRoutes(appCode)
      console.log('路由地址',accessRoutes)
      this.SET_ROUTES(accessRoutes)
      await this.initializeLang()
      await this.setButtons()
      window.location.href = location.host + '/platform/page_control'
      // this.$router.push(`/platform/page_control`)
    }
  }
})
